<template>
  <div>
    <router-view />
    <notifications position="bottom right" />
  </div>
</template>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
</style>
